import React, { useEffect, useState } from "react";
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import ButtonComponent from "@/components/button/Button";
import { setCurrentForm, setFormProps, setModalOpen } from "@/reducers/commonSlice";
import { useDispatch } from "react-redux";

export default function CheckoutForm() {
  const stripe = useStripe();
  const elements = useElements();
  const dispatch = useDispatch();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Something went wrong.");
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);
    sessionStorage.setItem("fromCheckout", "true");

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        return_url: window.location.origin + "/dashboard",
      },
    });

    // This point will only be reached if there is an immediate error when
    // confirming the payment. Otherwise, your customer will be redirected to
    // your `return_url`. For some payment methods like iDEAL, your customer will
    // be redirected to an intermediate site first to authorize the payment, then
    // redirected to the `return_url`.
    if (error.type === "card_error" || error.type === "validation_error") {
      setMessage(error.message);
    } else {
      setMessage("An unexpected error occurred.");
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  useEffect(() => {
    let isUserLeaving = false;
    let isReloading = false;

    const showCustomPopup = async () => {
      if (isReloading) return;

      dispatch(setCurrentForm("confirmDelete"));
      dispatch(setModalOpen(true));
      dispatch(
        setFormProps({
          onSubmit: () => {
            isUserLeaving = true;
            dispatch(setModalOpen(false));
            if (isReloading) {
              window.location.reload();
            } else {
              window.history.back();
            }
          },
          onCancel: () => {
            dispatch(setModalOpen(false));
            // Push a new state after canceling
            window.history.pushState(null, "", window.location.href);
          },
          message: "Are you sure you want to cancel the transaction?",
        })
      );
    };

    // Handle beforeunload (refresh/close tab)
    const handleBeforeUnload = (event) => {
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedCode = urlParams.get("data");

      if (encryptedCode && !isUserLeaving) {
        event.preventDefault();
        isReloading = true;
        showCustomPopup();
        // Prevent the default browser alert
        event.returnValue = "";
        return "";
      }
    };

    // Handle back button
    const handleBackButton = (event) => {
      const urlParams = new URLSearchParams(window.location.search);
      const encryptedCode = urlParams.get("data");

      if (encryptedCode && !isUserLeaving) {
        event.preventDefault();
        isReloading = false;
        showCustomPopup();
      }
    };

    // Add event listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handleBackButton);

    // Push initial state
    if (window.history && window.history.pushState) {
      window.history.pushState(null, "", window.location.href);
    }

    // Cleanup event listeners
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handleBackButton);
    };
  }, [dispatch]);

  // Add a separate effect to handle the initial history state
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedCode = urlParams.get("data");

    if (encryptedCode && window.history && window.history.pushState) {
      window.history.pushState(null, "", window.location.href);
    }
  }, []);

  return (
    <form id="payment-form" onSubmit={handleSubmit}>
      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <ButtonComponent label="Pay Now" htmlType="submit" varient="primary" id="submit" />
      {/* <button label="Pay Now" varient="primary" id="submit">Pay now</button> */}
      {/* <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">
          {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
        </span>
      </button> */}
      {/* Show any error or success messages */}
      {message && <div id="payment-message center">{message}</div>}
    </form>
  );
}
